var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSpeakerLow = function SvgIconSpeakerLow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.69 2.102a1 1 0 0 1 .56.898v18a1 1 0 0 1-1.614.79l-6.48-5.04H3A1.75 1.75 0 0 1 1.25 15V9A1.75 1.75 0 0 1 3 7.25h4.157l6.48-5.04a1 1 0 0 1 1.052-.108m-1.44 2.943L8.5 8.739v6.522l4.75 3.694zm-10 4.205H6.5v5.5H3.25zm15.325-.077a1 1 0 0 0-1.412 1.417 1.99 1.99 0 0 1 0 2.82 1 1 0 1 0 1.412 1.417 3.99 3.99 0 0 0 0-5.654",
    clipRule: "evenodd"
  })));
};
export default SvgIconSpeakerLow;